import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/phone_numbers/configure_phone_number.vue'

export default class extends Controller {
  static values = {
    defaultRecordingWarning: String,
    defaultVoiceMailMessage: String,
    phoneNumber: Object,
    timeZones: Array
  }

  connect() {
    const props = {
      defaultRecordingWarning: this.defaultRecordingWarningValue,
      defaultVoiceMailMessage: this.defaultVoiceMailMessageValue,
      phoneNumber: this.phoneNumberValue,
      timeZones: this.timeZonesValue
    }

    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
